var hasURLSearchParams = typeof window !== 'undefined' && typeof URLSearchParams !== 'undefined';
var getParam = function getParam(key) {
  if (!hasURLSearchParams) return null;
  var searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(key);
};
export { getParam };